<script setup lang="ts">
import { OverlayElement, ParagraphText, ParagraphLinklist } from '~/api/graphql/generated'

const props = defineProps<{
  entity: OverlayElement
}>()

const fieldItems = computed(() => {
  return props.entity?.fieldWidgets?.map((item) => {
    const pt = item?.entity as ParagraphText
    const pll = item?.entity as ParagraphLinklist
    if (pt.__typename === 'ParagraphText')
      return {
        type: 'ParagraphText',
        processed: pt.fieldText?.processed,
      }
    else
      return {
        type: 'ParagraphLinklist',
        title: pll.fieldTitle ?? undefined,
        links:
          pll.fieldLinks?.map((fieldLink) => {
            return {
              id: fieldLink?.title ?? 0,
              link: {
                text: fieldLink?.title || '',
                url: fieldLink?.url?.path || '',
                target: fieldLink?.attribute || '', //???
              },
            }
          }) || [],
      }
  })
})
</script>

<template>
  <div class="modal-content-container">
    <h1 class="field-overlay-title">{{ entity?.label }}</h1>
    <div v-for="(fieldItem, index) in fieldItems" :key="'overlayWidget' + index">
      <div v-if="fieldItem?.type === 'ParagraphText'" class="paragraph">
        <TextSpecial :text="fieldItem?.processed" />
      </div>
      <div v-if="fieldItem?.type === 'ParagraphLinklist'" class="paragraph">
        <h3>{{ fieldItem.title }}</h3>
        <LinkList v-if="fieldItem.links" :items="fieldItem.links" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-content-container {
  max-width: 800px;
  padding-left: 24px;
  .paragraph {
    padding-bottom: 48px;
    @include breakpoint(tl) {
      padding-bottom: 64px;
    }
  }
  .field-overlay-title {
    font-size: 28px;
    line-height: 32.2px;
    @include breakpoint(tl) {
    }
    @include breakpoint(ds) {
      font-size: 44px;
      line-height: 50.6px;
    }
  }
  .overlay-image-container {
    height: 340px;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    @include breakpoint(tl) {
      height: 440px;
    }
    .dp-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
